<template>
  <div class="create-button" @click="$emit('clicked')">
    <i class="fal fa-plus"></i>
  </div>
</template>

<script>
export default {
  props: ['callback']
}
</script>



// WEBPACK FOOTER //
// src/components/actions/CreateNewButton.vue